import React from 'react';
import Alert from '@material-ui/lab/Alert';

export default function ReusedFieldWarning({message, events=[]}) {
    // const events = useSelector(getEvents)
    // const [msgReuseCount, setMsgReuseCount] = useState(0)

    // useEffect(() => {
        // const eventsWithMessage = events.filter(event => event.message === message.id)
        // setMsgReuseCount(eventsWithMessage.length)

    // }, [])
    
    return (
        <>                  
        { events.length>1 && <Alert icon={false} severity="warning"> The event type is used in multiple events {events.join(", ")}. Updating this field will affect these events.</Alert>}
        </>

    )
}